import { isEmpty, isEqual, isNil } from 'lodash';
import { requestGet, requestPost } from '@/service/coa/cspUtil';
import { azure, gcp } from '@/service/coa/csp';

const promiseNothing = () => Promise.resolve(null);
const findProvider = (typeCode, providers) => providers.find(provider => isEqual(typeCode && typeCode.toUpperCase(), provider.typeCode));

/* login */
const _loginPopupProps = {
  popup: null,
  checkTimer: null,
  data: {
    azure: {
      accessManagementToken: '',
      accessGraphToken: '',
    },
    gcp: {
      accessToken: '',
      idToken: '',
    },
  },
};

const initLoginPopup = () => {
  _loginPopupProps.popup = null;
  _loginPopupProps.checkTimer = null;
  _loginPopupProps.data.azure.accessManagementToken = '';
  _loginPopupProps.data.azure.accessGraphToken = '';
  _loginPopupProps.data.gcp.accessToken = '';
  _loginPopupProps.data.gcp.idToken = '';
};

const showLoginPopup = (url, props) => {
  const popupLayerId = 'idCoaCspPopupLayer';

  if (window && window.screen) {
    const popWidth = props.width || 600;
    const popHeight = props.height || 400;
    const popLeft = props.left || (window.screen.width / 2) - (popWidth / 2);
    const popTop = props.top || (window.screen.height / 2) - (popHeight / 2);

    initLoginPopup();
    window.addEventListener('message', messageEventListener);

    _loginPopupProps.popup = window && window.open(url, '', `height=${popHeight}, width=${popWidth}, left=${popLeft}, top=${popTop}`);
    if (!isNil(_loginPopupProps.popup)) {
      const layerStyle = `position:absolute;display:;z-index:1001;left:0px;top:0px;width:100vw;height:100vh;opacity:0.4;background-color:#000;`;
      $("body", window.document).append(`<div id="${popupLayerId}" style="${layerStyle};"></div>`);
      if ($(`#${popupLayerId}`, window.document).length > 0) {
        $(`#${popupLayerId}`).on('click', () => {
          if (!isNil(_loginPopupProps.popup)) {
            _loginPopupProps.popup.focus();
          }
        })
      }

      _loginPopupProps.checkTimer = setInterval(() => {
        if (isNil(_loginPopupProps.popup) || _loginPopupProps.popup.closed) {
          clearInterval(_loginPopupProps.checkTimer);

          if ($(`#${popupLayerId}`, window.document).length > 0) {
            $(`#${popupLayerId}`, window.document).remove();
          }
          
          window.removeEventListener('message', messageEventListener);
          initLoginPopup();
        }
      }, 500)
    }

    return _loginPopupProps.popup;
  }
}

const messageEventListener = event => {
  event.preventDefault();

  const map = [{
    key: azure.key,
    handler: data => {
      const azureData = _loginPopupProps.data.azure;
      if (isEqual(data.scope, azure.authorizeScopeDomain.management)) {
        azureData.accessManagementToken = data.accessToken;
      } else if (isEqual(data.scope, azure.authorizeScopeDomain.graph)) {
        azureData.accessGraphToken = data.accessToken;
      }

      if (!isEmpty(azureData.accessManagementToken) && !isEmpty(azureData.accessGraphToken)) {
        saveToken(azure, {
          mgmtToken: azureData.accessManagementToken,
          graphToken: azureData.accessGraphToken,
        })
      }
    }
  },
  {
    key: gcp.key,
    handler: data => {
      const gcpData = _loginPopupProps.data.gcp;
      if (isEqual(data.scope, gcp.authorizeScopeDomain)) {
        gcpData.accessToken = data.accessToken;
        gcpData.idToken = data.idToken;
      }

      if (!isEmpty(gcpData.accessToken) && !isEmpty(gcpData.idToken)) {
        saveToken(gcp, {
          accessToken: gcpData.accessToken,
          idToken: gcpData.idToken,
        })
      }
    }
  }];

  if (!isNil(event) && !isNil(event.data)) {
    const csp = map.find(provider => isEqual(provider.key, event.data.key));
    if (!isNil(csp)) {
      csp.handler(event.data);
    }
  }
}

const saveToken = async (provider, token) => {
  if (!isNil(provider) && !isNil(token)) {
    return requestPost('/cop/coa/cache/setAccessToken', Object.assign({
      'tenant': provider.tenantId,
      'cspKey': provider.key,
    }, token))
    .then(data => {
      return data;
    });
  }

  return _promiseNothing();
}

/* service */
const getLoginHint = async (typeCode, param) => {
  const apis = [
    { typeCode: azure.typeCode, path: '/cop/coa/roles/selectAzureInfo' },
    { typeCode: gcp.typeCode, path: '/cop/coa/roles/selectAzureInfo' },
  ];

  const api = apis.find(api => isEqual(typeCode && typeCode.toUpperCase(), api.typeCode));
  if (!isNil(api)) {
    return requestGet(api.path, param)
    .then(data => {
      return data && `${data.knoxId || ''}@${data.domainId || ''}`;
    });
  }

  return _promiseNothing();
}

const login = async (typeCode, loginHint) => {
  if (isEmpty(loginHint) && [ azure ].find(csp => isEqual(csp.typeCode, typeCode))) {
    loginHint = await getLoginHint(typeCode);
    console.log('LOGINHINT', loginHint)
  }

  const provider = findProvider(typeCode, [ azure, gcp ]);
  if (!isNil(provider)) {
    const url = provider.authorizeUrl(loginHint);
    if (!isEmpty(url)) {
      console.log('CSPLOGIN-URL', url)
      showLoginPopup(url, provider.authorizeWindowFeatures);
    }
  }

  return promiseNothing();
}

export default {
  getLoginHint,
  login,
}



// WEBPACK FOOTER //
// ./src/service/coa/cspLoginService.js